<script setup lang="ts">
import type { PlayerStatistic } from '@acepoker/contract'
import ScoreInfo from './ScoreInfo.vue'

const props = defineProps<{ statistic: PlayerStatistic; size?: 'small' | 'large' }>()
</script>

<template>
  <div class="grid grid-cols-2 gap-2 w-full">
    <ScoreInfo
      :size="props.size"
      :value="props.statistic.handsTotal / props.statistic.sessions"
      :title="$t('Statistic.label.HandsPlayed')"
    />
    <ScoreInfo
      :size="props.size"
      :value="props.statistic.handsTotal"
      :title="$t('Statistic.label.TotalHands')"
    />
    <ScoreInfo
      :size="props.size"
      :value="
        props.statistic.totalEVLoss.toFixed(statistic.totalEVLoss === 0 ? statistic.totalEVLoss : 2)
      "
      :title="$t('Statistic.label.TotalEV')"
    />
    <ScoreInfo
      :size="props.size"
      :value="
        props.statistic.avgEVLoss.toFixed(statistic.avgEVLoss === 0 ? statistic.avgEVLoss : 2)
      "
      :title="$t('Statistic.label.AvgEV')"
    />
  </div>
</template>
